/**
 * PreviewCanvas — renders a past version's editor state read-only.
 *
 * Given a throwaway in-memory Y.Doc reconstructed from that version's
 * snapshot (nodes + edges; grids are pre-seeded into the global grid store
 * by the caller), it reuses SitemapCanvas in `readOnly` mode. The doc has
 * NO persistence (no SqliteProvider/BroadcastProvider) and a throwaway
 * UndoManager — nothing here can touch the live editor doc or OPFS.
 */
import { useMemo } from "react";
import * as Y from "yjs";

import { SitemapCanvas } from "./SitemapCanvas.js";
import type { EditorDoc } from "./useEditorDoc.js";

export function PreviewCanvas({ ydoc }: { ydoc: Y.Doc }) {
  const editorDoc: EditorDoc = useMemo(
    () => ({
      ydoc,
      // Throwaway — preview is read-only, undo is never wired to keys here.
      undoManager: new Y.UndoManager([]),
      loaded: true,
      // Read-only preview is pre-seeded from its snapshot — never seed.
      canSeed: false,
    }),
    [ydoc],
  );
  return <SitemapCanvas editorDoc={editorDoc} readOnly />;
}
